{"version":"localhost","sha":"local","build_id":"local","tag":"colonyid","short_sha":"local","env":"local"}
